/**
 * Slim section header for the chef kitchen lists' default grouping
 * (Sheila 2026-08-22): a TYPE header (Mains / Sides / Condiments /
 * Beverages — and the ingredient list's USDA categories) with an
 * optional row count. Rows inside a group are temperature-ORDERED
 * (hot → chilled → ambient) with no per-temperature headings — the
 * ordering itself is the organization, per Sheila's follow-up.
 */

export function ListGroupHeader({ label, count }: { label: string; count?: number }) {
  return (
    <div className="flex items-baseline gap-2 border-b border-border bg-muted/40 px-4 py-1.5 lg:px-6">
      <span className="text-xs font-semibold uppercase tracking-wide text-muted-foreground">{label}</span>
      {count !== undefined ? (
        <span className="text-xs text-muted-foreground/70">
          {count} SKU{count === 1 ? '' : 's'}
        </span>
      ) : null}
    </div>
  )
}
